<template>
  <v-progress-linear v-if="loading" indeterminate />
  <div v-else class="rounded" ref="scrollContainer"
    :class="{ 'dashboard-appointments-mobile': $vuetify.breakpoint.mobile }" :style="wrapperStyle" @scroll="onScroll">
    <v-alert dense border="left" type="warning" v-if="!bankingInfoAdded || !packageDone">
      Please add your payout and package information from
      <router-link color="white" class="rounded light font-weight-bold" to="/packages">
        here
      </router-link>
      in order to be approved.
    </v-alert>

    <v-alert dense border="left" type="warning" v-if="!docsDone">
      Please upload required documents under professional information from
      <router-link color="white" class="rounded light font-weight-bold" to="/settings">
        settings
      </router-link>
      page.
    </v-alert>
    <v-card class="mb-5" v-if="!notification">
      <v-card-text class="pb-0">
        <v-row>
          <v-col cols="12" class="pb-0">
            <!-- <v-select
              v-model="filterItem"
              label="Select Search Category"
              :items="[
                ...headers.filter(
                  ({ value }) => value !== 'start' && value !== 'end'
                ),
                { text: 'Date Range', value: 'date' },
              ]"
              prepend-icon="mdi-cog"
              outlined
              dense
            /> -->
            <v-btn v-for="category in [
              ...headers.filter(
                ({ value }) => value !== 'start' && value !== 'end'
              ),
              { text: 'Date Range', value: 'date' },
            ]" :key="category.value" v-text="category.text" :x-small="$vuetify.breakpoint.mobile"
              :small="!$vuetify.breakpoint.mobile" rounded class="mb-2 mr-2"
              :color="filterItem === category.value ? 'primary' : ''" active-class="active"
              @click="filterItem = category.value" />
          </v-col>
          <v-col cols="12">
            <div active-class="primary--text" column v-if="filterItem === 'status'">
              <v-btn :class="{
                'primary--text v-chip-active':
                  status === 'All' && !filterText,
              }" v-for="status in [
                'All',
                'Declined',
                'Pending',
                'Finished',
                'Approved',
              ]" :key="status" @click="filterText = status === 'All' ? '' : status; runSearch()" small>
                {{ status }}
              </v-btn>
            </div>
            <v-dialog v-else-if="filterItem === 'date'" ref="datePickerDialog" v-model="datePickerDialog"
              :return-value.sync="selectedDates" persistent width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="selectedDatesText" label="Date Range" prepend-icon="mdi-calendar" readonly
                  outlined dense v-bind="attrs" v-on="on" />
              </template>
              <v-date-picker v-model="selectedDates" range scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="datePickerDialog = false">
                  Cancel
                </v-btn>
                <v-btn text color="primary" @click="onDateRangeOk()">
                  OK
                </v-btn>
              </v-date-picker>
            </v-dialog>
            <v-text-field v-else v-model="filterText" :label="_.startCase(filterItem)" prepend-icon="mdi-magnify"
              outlined dense @keyup.enter="runSearch" />
          </v-col>
          <v-spacer v-if="dashboardView !== 'card'" />
          <v-col md="auto" v-if="dashboardView !== 'card'">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" @click="
                  toggleDashboardView(
                    dashboardView === 'list' ? 'calendar' : 'list'
                  )
                  ">
                  <v-icon v-if="dashboardView !== 'list'">mdi-apps</v-icon>
                  <v-icon v-if="dashboardView !== 'calendar'">mdi-calendar</v-icon>
                </v-btn>
              </template>
              <span>{{ dashboardView === "list" ? "Calendar" : "List" }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- Total / out of (filter-aware) -->
    <div v-if="!notification" class="d-flex align-center px-2 py-2 text-caption text--secondary flex-wrap"
      style="gap: 4px;">
      <span>Showing <strong>{{ filteredAppointments.length }}</strong> appointments</span>
      <template v-if="totalAppointmentsCount != null">
        <span>of <strong>{{ totalAppointmentsCount }}</strong></span>
      </template>
      <span v-else-if="!hasMore && filteredAppointments.length > 0"></span>
    </div>
    <List v-if="dashboardView === 'list'" :loading="loading" :headers="headers" :appointments="filteredAppointments"
      :getColor="getColor" :showDialog="showDialog" />
    <div ref="loadMoreSentinel" v-if="dashboardView === 'list' && hasMore && !loading" class="text-center py-3">
      <v-btn v-if="!loadingMore" small outlined @click="loadMore">Load more</v-btn>
      <v-progress-circular v-else indeterminate size="24" />
    </div>
    <Calendar v-if="dashboardView === 'calendar'" :loading="loading" :appointments="filteredAppointments"
      :getColor="getColor" :showDialog="showDialog" />
    <Card v-if="dashboardView === 'card'" :loading="loading" :headers="headers" :appointments="filteredAppointments"
      :getColor="getColor" :showDialog="showDialog" />
    <v-dialog v-model="dialog" persistent max-width="375" v-if="appointment">
      <v-card>
        <v-card-text class="pt-5">
          <div class="d-flex align-center">
            <v-avatar size="70">
              <img :src="appointment.profilePicture" />
            </v-avatar>
            <div>
              <v-chip x-small dark :color="appointment.color" class="ml-4">{{
                appointment.status
                }}</v-chip>
              <v-card-title class="py-0 headline">{{
                appointment.name
                }}</v-card-title>
              <div class="ml-3">
                <v-chip x-small color="warning" class="ml-1" v-if="
                  appointment.type[0] === 'roadtest_rent_car' ||
                  appointment.type[0] === 'rentcar_n_lesson'
                ">
                  Road Test
                </v-chip>
                <v-chip x-small color="success" class="ml-1" v-if="
                  appointment.type[0] === 'booking_lesson' ||
                  appointment.type[0] === 'rentcar_n_lesson'
                ">
                  Lesson
                </v-chip>
              </div>
            </div>
            <v-btn class="ml-auto align-self-start" small fab elevation="0" @click="
              dialog = false;
            selectedAppointmentDate = null;
            ">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-row align="end">
            <v-col>
              <p class="mb-0">
                <strong>Duration:</strong>
                {{
                  $moment
                    .duration(
                      $moment(appointment.end).diff($moment(appointment.start))
                    )
                    .asHours()
                }}hr
              </p>
              <p class="mb-0">
                <strong>Location:</strong> {{ appointment.location }}
              </p>
              <v-btn small @click="showMap" target="_blank" class="mt-3" v-if="
                userType === 'instructor' && appointment.status === 'Approved'
              ">
                <v-icon left>mdi-map-marker</v-icon>
                map
              </v-btn>
              <div class="mt-4 d-flex">
                <v-btn outlined fab dark small color="primary" :href="`mailto:${appointment.studentEmail}`">
                  <v-icon dark> mdi-email </v-icon>
                </v-btn>
                <v-btn class="ml-2" outlined fab dark small color="primary" :href="`tel:${appointment.phone}`">
                  <v-icon dark> mdi-phone </v-icon>
                </v-btn>
                <v-btn class="ml-2" outlined fab dark small color="primary" :to="`/chat/${appointment.studentId}`">
                  <v-icon dark> mdi-chat </v-icon>
                </v-btn>
              </div>
            </v-col>
            <v-col cols="auto" v-if="
              appointment.status === 'Approved' ||
              !appointment.drivingLessonDates.length
            ">
              <v-btn v-if="isRealMobileDevice" color="warning" text block x-small @click="addToCalendar" class="mb-1">
                <v-icon>mdi-calendar-plus</v-icon>
              </v-btn>

              <Day :date="appointment.start" />
            </v-col>
            <v-col cols="12" v-if="appointment.roadtestOptions || appointment.roadtestOptions">
              <v-expansion-panels>
                <v-expansion-panel v-if="appointment.learningOptions">
                  <v-expansion-panel-header>
                    Learning Options
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    {{ appointment.learningOptions }}
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel v-if="appointment.roadtestOptions">
                  <v-expansion-panel-header>
                    Roadtest Options
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <template v-if="appointment.roadtestOptions === 'mockRoadTestG'">
                      Overview of all the basic driving skills, behaviors and
                      knowledge needed to pass the G driving exam. Includes an
                      overview of highway driving.
                    </template>
                    <template v-if="appointment.roadtestOptions === 'mockRoadTestG2'">
                      Overview of all the basic driving skills, behaviors and
                      knowledge needed to pass the G2 driving exam. Does not
                      include highway driving.
                    </template>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <template v-if="!!appointment.notes">
                <h4 class="mt-2">Notes</h4>
                <p class="mb-0">{{ appointment.notes }}</p>
              </template>
            </v-col>
            <v-col class="text-center" v-if="
              appointment.status === 'Pending' &&
              appointment.drivingLessonDates.length
            ">
              <h4 class="mb-2">Please choose from belows</h4>
              <select-day :dates="appointment.drivingLessonDates.map(
                ({ start }) => new Date(start)
              )
                " :activeDate="selectedAppointmentDate" @update:date="selectedAppointmentDate = $event" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-center pt-0 pa-5">
          <v-btn small color="success" class="white--text" @click="
            dialog = false;
          confirm = true;
          " v-if="
            appointment.status === 'Pending' ||
            appointment.status === 'Approved'
          ">
            Reschedule
          </v-btn>

          <v-btn small color="primary" @click="approveEvent" v-if="appointment.status === 'Pending'" :disabled="!!appointment.drivingLessonDates.length &&
            !selectedAppointmentDate
            ">
            Approve
          </v-btn>
          <v-btn small color="primary" @click="makeComplete = true" v-if="appointment.status === 'Approved'"
            :disabled="$moment().diff(appointment.start) <= 0">
            Complete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirm" persistent max-width="300">
      <v-card>
        <v-card-title class="headline"> Warning! </v-card-title>
        <v-card-text class="pb-0">
          Are you sure you want to reschedule this event? Current appointment
          will be removed if you select 'Yes'
          <v-textarea outlined label="Notes" v-model="rescheduleEventNotes" class="pb-0 mt-4 mb-0"
            placeholder="Note: You may add next available date/time you are available" dense></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="green darken-1" small text @click="confirm = false">
            No
          </v-btn>
          <v-btn color="red darken-1" small text @click="rescheduleEvent">
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="makeComplete" max-width="420" persistent>
      <v-card class="complete-booking-card text-center">
        <v-card-title class="justify-center headline primary--text py-3">
          Please Rate
        </v-card-title>
        <v-card-text class="pt-0 pb-2">
          <v-rating v-model="rating" color="warning" background-color="warning" half-increments dense size="32"
            class="mb-2" />
          <v-textarea outlined label="Add Comments" v-model="ratingFeedback" class="pb-0 mt-0 mb-2" dense rows="2" />
          <div class="text-left mt-2">
            <div class="subtitle-2 font-weight-medium mb-2">Checklist</div>
            <v-checkbox v-for="item in completionChecklist" :key="item" v-model="completionChecklistSelections"
              :label="item" :value="item" dense hide-details class="my-0" />
          </div>
          <!-- Instructor signature -->
          <div class="signature-section mt-4">
            <p class="caption mb-1 text-left font-weight-medium grey--text text--darken-1">
              Instructor signature
            </p>
            <VueSignaturePad ref="completionSignaturePad" class="completion-signature-pad"
              :options="completionSignatureOptions" />
            <div class="d-flex justify-space-between align-center mt-1">
              <v-btn x-small text color="grey" @click="undoCompletionSignature">
                Undo
              </v-btn>
            </div>
          </div>
          <v-btn block large color="primary" class="mt-4" :disabled="!canCompleteBooking" :loading="loading"
            @click="completeEvent">
            Complete Booking
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Parse from 'parse'
import { mapGetters, mapActions } from 'vuex'
import { VueSignaturePad } from 'vue-signature-pad'
import Calendar from '@/components/dashboard/Calendar'
import List from '@/components/dashboard/List'
import Card from '@/components/dashboard/Card'
import Day from '@/components/common/Day'
import SelectDay from '@/components/common/SelectDay'
import { iPhoneVersion, isIphone } from '../../utils'

export default {
  components: {
    VueSignaturePad,
    Calendar,
    List,
    Card,
    Day,
    SelectDay
  },
  props: {
    notification: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      loading: true,
      dialogShown: true,
      dialog: false,
      confirm: false,
      userType: localStorage.getItem('userType'),
      datePickerDialog: false,
      bankingInfoAdded: true,
      packageDone: false,
      docsDone: false,
      transfer_group: Date.now(),
      appointments: [],
      filteredAppointments: [],
      appointment: null,
      headers: [
        { text: 'Name', align: 'start', value: 'name' },
        { text: 'Start', value: 'start' },
        { text: 'End', value: 'end' },
        { text: 'Email', value: 'studentEmail' },
        { text: 'Location', value: 'location' },
        { text: 'Status', align: 'end', value: 'status' }
      ],
      filterItem: 'name',
      filterText: '',
      selectedDates: [],
      selectedDatesText: '',
      rescheduleEventNotes: '',
      selectedAppointmentDate: null,
      makeComplete: false,
      rating: 0,
      ratingFeedback: '',
      completionChecklist: [
        'Instruments devices',
        'Use of controls, brake, acceleration',
        'Steering hand over hand',
        'Right turns',
        'Left turns',
        'Two-point turns simple',
        'Three point turns',
        'Angle parking',
        'Perpendicular parking',
        'Parallel parking',
        'Parking on a hill',
        'Traffic lights',
        'Lane changes',
        'Highway Driving',
        'Road test evaluation'
      ],
      completionChecklistSelections: [],
      completionIsSigned: false,
      completionSignatureEmpty: true,
      completionSignatureOptions: {},
      isApprovedDisabled: true,
      isRealMobileDevice: typeof window.cordova !== 'undefined',
      pageSize: 5,
      loadingMore: false,
      hasMore: true,
      loadMoreObserver: null
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'dashboardView',
      'completeAppointment',
      'reviewRatings',
      'approveAppointment',
      'instructorAppointments',
      'paymenthistory',
      'transferQ',
      'declineAppment',
      'rescheduleAppment',
      'pushNotification',
      'checkReview'
    ]),
    wrapperStyle() {
      const mobile = this.$vuetify.breakpoint.mobile
      if (mobile) {
        return { position: 'relative', overflow: 'auto' }
      }
      const height = 92 + (this.isIphone10Avobe() ? 34 : 0)
      return {
        position: 'relative',
        overflow: 'auto',
        height: `calc(100vh - ${height}px)`
      }
    },
    canCompleteBooking() {
      return this.rating && this.completionIsSigned && !this.completionSignatureEmpty
    }
  },
  mounted() {
    this.completionSignatureOptions = {
      backgroundColor: '#fafafa',
      penColor: '#1a1a1a',
      onBegin: () => {
        this.$nextTick(() => {
          if (this.$refs.completionSignaturePad) {
            this.$refs.completionSignaturePad.resizeCanvas()
          }
        })
        this.completionIsSigned = true
      },
      onEnd: () => {
        this.checkCompletionSignature()
      }
    }
  },
  updated() {
    this.$nextTick(() => this.setupLoadMoreObserver())
  },
  beforeDestroy() {
    if (this.loadMoreObserver) {
      this.loadMoreObserver.disconnect()
      this.loadMoreObserver = null
    }
  },
  watch: {
    makeComplete(isOpen) {
      if (isOpen) {
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.onMakeCompleteDialogChange(true)
          })
        })
      }
    },
    filterItem() {
      this.filterItem !== 'status' && (this.filterText = '')
    },
    filterText() {
      this.filteredAppointments = this.appointments.filter((appointment) =>
        appointment[this.filterItem]
          .toLowerCase()
          .includes(this.filterText.toLowerCase())
      )
    },
    // No filterText watcher – search runs on Enter via runSearch()
    selectedDates(val) {
      const sortedDates = [...(val || [])].map((d) => this.$moment(d).format('YYYYMMDD'))
      if (sortedDates.length === 2) {
        this.selectedDatesText = (val || []).join(' ~ ')
      }
      // Don’t filter here – date filter is applied when user clicks OK and runSearch() is called
    },
    appointments(value) {
      this.filteredAppointments = value
        .filter((appointment) =>
          appointment[this.filterItem]
            .toLowerCase()
            .includes(this.filterText.toLowerCase())
        )
        .filter((appointment) =>
          this.notification ? appointment.status === 'Pending' : true
        )
      // Saving to store
      // this.getstatusAppointments(value);
    }
  },
  methods: {
    ...mapActions([
      'toggleDialog',
      'toggleDashboardView',
      'saveCompleteAppointment',
      'saveReviewRatings',
      'saveApprovedAppointment',
      'getInstructorAppointments',
      'addPayentHistory',
      'saveTransferQ',
      'updateUser',
      'declineAppointment',
      'rescheduleAppointment',
      'sendPushNotification',
      'checkReviewRatings'
    ]),
    isIphone10Avobe() {
      return (
        isIphone() &&
        ['iPhone-X-Xs', 'iPhone-Xmax-Xr', 'iPhone-12'].includes(iPhoneVersion())
      )
    },
    async init() {
      const self = this
      let start = new Date(1000, 0, 1) // Jan 1, 2000
      let end = new Date(6000, 0, 1)

      // Date range from picker (when user selected two dates)
      if (self.selectedDates && self.selectedDates.length === 2) {
        const [d1, d2] = [...self.selectedDates].sort()
        start = self.$moment(d1).startOf('day').toDate()
        end = self.$moment(d2).endOf('day').toDate()
      }
      const payload = {
        instructorId: self.user.id,
        start,
        end,
        limit: self.pageSize,
        skip: 0,
        append: false
      }
      // Status filter (when category is "status")
      if (self.filterItem === 'status' && self.filterText) {
        payload.status = self.filterText
      } else {
        payload.status = 'All'
      }
      // Location search
      if (self.filterItem === 'location' && self.filterText && self.filterText.trim()) {
        payload.location = self.filterText.trim()
      }
      // Name or email search (sent as searchText + searchType)
      if ((self.filterItem === 'name' || self.filterItem === 'email') && self.filterText && self.filterText.trim()) {
        payload.searchText = self.filterText.trim()
        payload.searchType = self.filterItem
      }
      try {
        const { hasMore, results, total } = await self.getInstructorAppointments(payload)
        if (results && results.length) {
          self.totalAppointmentsCount = total != null ? total : null
          const newMapped = results.map((instructorAppointment) => {
            const student = instructorAppointment.get('studentId')
            const status = instructorAppointment.get('status')
            return {
              appointmentId: instructorAppointment.id,
              prePaid: instructorAppointment.get('schoolPackageId') ? instructorAppointment?.get('schoolPackageId').get('prePaid') : false,
              studentId: student.id,
              name: `${student.get('firstName')} ${student.get('lastName')}`,
              studentLocation: student.get('location'),
              profilePicture: student.get('profilePicture'),
              studentEmail: student.get('customEmail'),
              studentPhone: student.get('phone'),
              studentStripCustomerId: student.get('stripeCustomerId'),
              studentStripPaymentMethodId: student.get('stripePaymentMethodId'),
              schoolStripeUserAccountId: typeof instructorAppointment.get('schoolPackageId') !== 'undefined' ? instructorAppointment.get('schoolPackageId').get('schoolId').get('associatedId').get('stripeUserAccountId') : '',
              schoolAssociatedId: typeof instructorAppointment.get('schoolPackageId') !== 'undefined' ? instructorAppointment.get('schoolPackageId').get('schoolId').get('associatedId').id : '',
              instructorFees: instructorAppointment.get('instructorPackageId'),
              phone: student.get('phone'),
              deviceId: student.get('deviceId'),
              type: instructorAppointment.get('type'),
              start: new Date(instructorAppointment.get('start')),
              end: new Date(instructorAppointment.get('end')),
              location: instructorAppointment.get('appoinmentLocation'),
              roadtestOptions: instructorAppointment.get('roadtestOptions'),
              learningOptions: instructorAppointment.get('learningOptions'),
              hoursLesson: instructorAppointment.get('hoursLesson') || null,
              color: self.getColor(status),
              drivingLessonDates: instructorAppointment.get('drivingLessonDates'),
              notes: instructorAppointment.get('notes'),
              status
            }
          })
          self.appointments = newMapped
          self.hasMore = hasMore === undefined ? false : hasMore
          self.filteredAppointments = self.appointments
        } else {
          self.appointments = []
          self.filteredAppointments = []
          self.hasMore = false
          self.totalAppointmentsCount = 0
        }
      } finally {
        self.loading = false
      }
    },
    async loadMore() {
      const self = this
      if (self.loadingMore || !self.hasMore || !self.user?.id) return
      self.loadingMore = true
      try {
        let start = new Date(1000, 0, 1)
        let end = new Date(6000, 0, 1)
        if (self.selectedDates && self.selectedDates.length === 2) {
          const [d1, d2] = [...self.selectedDates].sort()
          start = self.$moment(d1).startOf('day').toDate()
          end = self.$moment(d2).endOf('day').toDate()
        }
        const payload = {
          instructorId: self.user.id,
          start,
          end,
          limit: self.pageSize,
          skip: self.appointments.length,
          append: true
        }
        if (self.filterItem === 'status' && self.filterText) payload.status = self.filterText
        else payload.status = 'All'
        if (self.filterItem === 'location' && self.filterText?.trim()) payload.location = self.filterText.trim()
        if ((self.filterItem === 'name' || self.filterItem === 'email') && self.filterText?.trim()) {
          payload.searchText = self.filterText.trim()
          payload.searchType = self.filterItem
        }
        const { hasMore, results } = await self.getInstructorAppointments(payload)
        if (results && results.length) {
          const newMapped = results.map((instructorAppointment) => {
            const student = instructorAppointment.get('studentId')
            const status = instructorAppointment.get('status')
            return {
              appointmentId: instructorAppointment.id,
              prePaid: instructorAppointment.get('schoolPackageId') ? instructorAppointment?.get('schoolPackageId').get('prePaid') : false,
              studentId: student.id,
              name: `${student.get('firstName')} ${student.get('lastName')}`,
              studentLocation: student.get('location'),
              profilePicture: student.get('profilePicture'),
              studentEmail: student.get('customEmail'),
              studentPhone: student.get('phone'),
              studentStripCustomerId: student.get('stripeCustomerId'),
              studentStripPaymentMethodId: student.get('stripePaymentMethodId'),
              schoolStripeUserAccountId: typeof instructorAppointment.get('schoolPackageId') !== 'undefined' ? instructorAppointment.get('schoolPackageId').get('schoolId').get('associatedId').get('stripeUserAccountId') : '',
              schoolAssociatedId: typeof instructorAppointment.get('schoolPackageId') !== 'undefined' ? instructorAppointment.get('schoolPackageId').get('schoolId').get('associatedId').id : '',
              instructorFees: instructorAppointment.get('instructorPackageId'),
              phone: student.get('phone'),
              deviceId: student.get('deviceId'),
              type: instructorAppointment.get('type'),
              start: new Date(instructorAppointment.get('start')),
              end: new Date(instructorAppointment.get('end')),
              location: instructorAppointment.get('appoinmentLocation'),
              roadtestOptions: instructorAppointment.get('roadtestOptions'),
              learningOptions: instructorAppointment.get('learningOptions'),
              hoursLesson: instructorAppointment.get('hoursLesson') || null,
              color: self.getColor(status),
              drivingLessonDates: instructorAppointment.get('drivingLessonDates'),
              notes: instructorAppointment.get('notes'),
              status
            }
          })
          self.appointments = self.appointments.concat(newMapped)
          self.hasMore = hasMore === undefined ? false : hasMore
          self.filteredAppointments = self.appointments
        } else {
          self.hasMore = false
        }
      } finally {
        self.loadingMore = false
      }
    },
    onScroll(e) {
      console.log('[scroll] onScroll called', {
        target: e?.target?.className || e?.target?.tagName,
        dashboardView: this.dashboardView,
        loadingMore: this.loadingMore,
        hasMore: this.hasMore,
        hasUser: !!this.user?.id
      })
      if (!['list', 'card'].includes(this.dashboardView) || this.loadingMore || !this.hasMore || !this.user?.id) {
        console.log('[scroll] onScroll early return (guard failed)')
        return
      }
      const el = e?.target
      if (el && typeof el.scrollHeight !== 'undefined') {
        const distance = el.scrollHeight - el.scrollTop - el.clientHeight
        console.log('[scroll] distance from bottom', distance)
        if (distance > 200) {
          console.log('[scroll] not near bottom, skip loadMore')
          return
        }
      }
      console.log('[scroll] calling loadMore()')
      this.loadMore()
    },
    setupLoadMoreObserver() {
      if (this.dashboardView !== 'list' || !this.$refs.scrollContainer || !this.$refs.loadMoreSentinel) return
      if (!this.loadMoreObserver) {
        const self = this
        this.loadMoreObserver = new IntersectionObserver(
          (entries) => {
            if (!entries[0]?.isIntersecting) return
            if (self.loadingMore || !self.hasMore || !self.user?.id) return
            self.loadMore()
          },
          { root: this.$refs.scrollContainer, rootMargin: '600px', threshold: 0 }
        )
      }
      this.loadMoreObserver.observe(this.$refs.loadMoreSentinel)
    },
    getColor(status) {
      switch (status) {
        case 'Declined':
          return 'red'
        case 'Pending':
          return 'grey'
        case 'Finished':
          return 'success'
        default:
          return 'primary'
      }
    },
    showDialog(e) {
      this.appointment = e.event
      console.log('thiis =', this.appointment)
      this.dialog = true
    },
    showMap() {
      // https://www.google.com/maps/search/?api=1&query=23.7830758,90.3898502
      if (this.appointment.studentLocation) {
        let url = 'https://www.google.com/maps/search/?api=1&query='
        if (typeof window.cordova !== 'undefined') {
          if (window.device.platform === 'iOS') {
            url =
              'maps://?q=' +
              this.appointment.studentLocation._latitude +
              ',' +
              this.appointment.studentLocation._longitude
            var target = '_system'
            window.cordova.InAppBrowser.open(url, target)
          } else {
            const geocoords =
              this.appointment.studentLocation._latitude +
              ',' +
              this.appointment.studentLocation._longitude
            const label = encodeURI(this.appointment.location) // encode the label!
            window.cordova.InAppBrowser.open(
              'geo:' + geocoords + '?q=' + geocoords + '(' + label + ')',
              '_system'
            )
          }
        } else {
          /** Just for the web */
          window.open(
            url +
            this.appointment.studentLocation._latitude +
            ',' +
            this.appointment.studentLocation._longitude
          )
        }
      }
    },
    async approveEvent() {
      var bookingLesson = false
      if (this.appointment.type[0] === 'booking_lesson') {
        bookingLesson = true
      }
      await this.saveApprovedAppointment({
        appointmentId: this.appointment.appointmentId,
        status: 'Approved',
        bookingLesson: bookingLesson,
        selectedAppointmentDate: this.selectedAppointmentDate,
        appointmentStart: this.appointment.start,
        appointmentEnd: this.appointment.end
      })
      this.dialog = false
      if (this.approveAppointment) {
        const displayDate = this.selectedAppointmentDate || this.appointment.start
        /** send push notification to the student */
        if (typeof this.appointment.deviceId !== 'undefined') {
          await this.sendPushNotification({
            player_id: this.appointment.deviceId,
            message: 'Appointment approved on ' + (displayDate ? this.$moment(displayDate).format('LLL') : 'your requested date'),
            type: 'noti',
            senderId: this.user.id,
            name: this.user.get('firstName') + ' ' + this.user.get('lastName')
          })
        }

        const option = displayDate ? this.$moment(displayDate).format('LLL') : 'your requested date'
        /** Send text */
        const smsMessage =
          this.user.get('firstName') +
          ' ' +
          this.user.get('lastName') +
          ' has approved your requested appointment on ' +
          option +
          ' Please log in to the DriverX app for more details.'
        const smsData = {
          message: smsMessage,
          to: this.appointment.studentPhone
        }
        /** call the cloud function */
        Parse.Cloud.run('sendAppointmentSMS', smsData).then((result) => {
          console.log('Text successful' + JSON.stringify(result))
        })

        /** Send email notification */
        Parse.Cloud.run('approvedEmail', {
          name: this.appointment.name,
          instructorName:
            this.user.get('firstName') + ' ' + this.user.get('lastName'),
          date: this.appointment.start,
          email: this.appointment.studentEmail
        })
          .then((res) => {
            console.log(res)
          })
          .catch((error) => {
            console.log(error)
          })
        this.toggleDialog({
          status: true,
          title: 'Success',
          message: 'Appointment Approved!'
        })
        this.appointment = null
        /** Call the initial function to reload in the BG */
        this.init()
      } else {
        // eslint-disable-next-line indent
        this.appointment = null
        this.toggleDialog({
          status: true,
          title: 'Error',
          message: 'Something went wrong, please try again.'
        })
      }
    },
    onMakeCompleteDialogChange(isOpen) {
      if (isOpen) {
        this.$nextTick(() => {
          if (this.$refs.completionSignaturePad) {
            this.$refs.completionSignaturePad.clearSignature()
          }
          this.completionIsSigned = false
          this.completionSignatureEmpty = true
        })
      }
    },
    checkCompletionSignature() {
      const pad = this.$refs.completionSignaturePad
      if (!pad) return
      this.completionSignatureEmpty = pad.isEmpty()
    },
    undoCompletionSignature() {
      const pad = this.$refs.completionSignaturePad
      if (pad) {
        pad.undoSignature()
        this.checkCompletionSignature()
      }
    },
    async completeEvent() {
      const self = this
      if (!self.appointment?.appointmentId) return

      const signaturePad = self.$refs.completionSignaturePad
      const signatureData = signaturePad && !signaturePad.isEmpty()
        ? signaturePad.saveSignature().data
        : null

      console.log('Completing appointment:', self.appointment.appointmentId)
      self.loading = true
      self.makeComplete = false
      self.dialog = false

      try {
        // 1. Package & free-bookings check. Students within their package limit
        // are never charged; bookings beyond the limit are charged to the
        // student's card on completion (step 5).
        const entitlement = await this.studentFreeBookingsAvailale(self.appointment.studentId)
        if (!entitlement.hasPackage) {
          self.toggleDialog({
            status: true,
            title: 'Cannot Complete Booking',
            message: 'This student has not purchased a package yet. Please ask the student to buy a package in the app, then complete this booking again.'
          })
          return
        }
        const studentHasFreeBookings = entitlement.hasFreeBookings
        console.log('Student has free bookings:', studentHasFreeBookings)

        // 2. When a charge is due, resolve the fee through a fallback chain so a
        // missing instructor rate can never block completion:
        //   1) school rate set for this instructor (school-associated bookings)
        //   2) the instructor's own rate for this booking type
        //   3) the per-lesson price of the student's package (price / included bookings)
        let fees = 0
        if (!studentHasFreeBookings) {
          const pkg = self.appointment.instructorFees
          const typeVal = self.appointment.type
          const feeKey = Array.isArray(typeVal) ? typeVal[0] : typeVal
          const hasInstructorPkg = pkg && typeof pkg.get === 'function'
          let rate = null

          if (hasInstructorPkg && self.appointment.schoolAssociatedId && Number(pkg.get('school_rate')) > 0) {
            rate = Number(pkg.get('school_rate'))
          }
          if (rate === null && hasInstructorPkg && Number(pkg.get(feeKey)) > 0) {
            rate = Number(pkg.get(feeKey))
          }
          if (rate === null) {
            const packagePrice = Number(entitlement.packageData?.get('price'))
            const includedBookings = Number(entitlement.freeBookings)
            if (packagePrice > 0 && includedBookings > 0) {
              rate = packagePrice / includedBookings
            }
          }
          if (rate === null || Number.isNaN(rate) || rate <= 0) {
            self.toggleDialog({
              status: true,
              title: 'Cannot Complete Booking',
              message: 'No price is set for this booking type yet. Please add your package rates under Settings, then complete this booking again.'
            })
            return
          }

          fees = self.appointment.hoursLesson
            ? rate * parseInt(self.appointment.hoursLesson, 10)
            : rate

          // The student pays by card for extra bookings — make sure a card is on
          // file BEFORE the booking is marked as finished.
          if (!self.appointment.studentStripCustomerId || !self.appointment.studentStripPaymentMethodId) {
            self.toggleDialog({
              status: true,
              title: 'Payment Card Missing',
              message: 'This student has used all bookings included in their package, so this extra booking must be paid by card — but the student has no card on file. Please ask the student to add a payment card in the app, then complete this booking again.'
            })
            return
          }
        }

        // 3. Mark appointment as "Finished"
        await self.saveCompleteAppointment({
          appointmentId: self.appointment.appointmentId,
          status: 'Finished',
          paid: !studentHasFreeBookings // Mark as paid only if no free bookings
        })

        // 4. Only proceed if appointment was successfully updated
        if (self.completeAppointment) {
          // Reload appointments
          await self.init()

          // 5. Charge student ONLY if no free bookings left
          if (!studentHasFreeBookings) {
            console.log('Stripe API will be called: student has NO free bookings left')
            try {
              console.log('Attempting Stripe charge...')
              console.log('Stripe payment method ID for this student!', self.appointment.studentStripPaymentMethodId)
              const chargeResult = await Parse.Cloud.run('chargeCardForAppointment', {
                amount: Math.round(Number(fees) * 100),
                customerId: self.appointment.studentStripCustomerId,
                paymentMethodId: self.appointment.studentStripPaymentMethodId,
                transfer_group: self.transfer_group
              })

              if (chargeResult.status === 'succeeded') {
                console.log('Stripe charge successful')

                // Record transfer to instructor (80%)
                await self.saveTransferQ({
                  appointmentId: self.appointment.appointmentId,
                  amount: Math.round(80 * Number(fees)) / 100,
                  userId: self.user.id,
                  ownerAccountId: self.user.get('stripeUserAccountId'),
                  transfer_group: self.transfer_group.toString(),
                  stripePaymentId: chargeResult.id
                })

                // Record transfer to school (20% if applicable)
                if (self.appointment.schoolStripeUserAccountId) {
                  await self.saveTransferQ({
                    appointmentId: self.appointment.appointmentId,
                    amount: Math.round(20 * Number(fees)) / 100,
                    userId: self.appointment.schoolAssociatedId,
                    ownerAccountId: self.appointment.schoolStripeUserAccountId,
                    transfer_group: self.transfer_group.toString(),
                    stripePaymentId: chargeResult.id
                  })
                }
              } else {
                throw new Error(chargeResult.message || 'The card was declined.')
              }
            } catch (error) {
              console.error('Payment error:', error)
              // The charge failed, so the booking must not stay "Finished":
              // put it back to Approved so it can be completed again later.
              await self.saveCompleteAppointment({
                appointmentId: self.appointment.appointmentId,
                status: 'Approved',
                paid: false
              })
              await self.init()
              self.toggleDialog({
                status: true,
                title: 'Payment Failed',
                message: 'The student\'s card could not be charged (' + (error.message || 'payment declined') + '). The booking has been put back to Approved — please ask the student to check their payment card, then complete it again.'
              })
              return
            }
          } else {
            console.log('No charge applied (student has free bookings)')
          }

          // 6. Save review/rating
          const reviewExists = await self.checkReviewRatings({
            reviewFrom: self.user.id,
            reviewFor: self.appointment.studentId,
            appointmentId: self.appointment.appointmentId
          })

          if (reviewExists) {
            await self.saveReviewRatings({
              appointmentId: self.appointment.appointmentId,
              reviewFrom: self.user.id,
              reviewFor: self.appointment.studentId,
              star: Number(self.rating),
              review: self.ratingFeedback,
              checklist: self.completionChecklistSelections,
              instructorSignature: signatureData,
              reviewId: self.checkReview
            })
          } else {
            await self.saveReviewRatings({
              appointmentId: self.appointment.appointmentId,
              reviewFrom: self.user.id,
              reviewFor: self.appointment.studentId,
              star: Number(self.rating),
              review: self.ratingFeedback,
              checklist: self.completionChecklistSelections,
              instructorSignature: signatureData
            })
          }

          // 7. Show success message
          self.toggleDialog({
            status: true,
            title: 'Booking Completed',
            message: 'The booking was completed successfully.'
          })

          // 8. Reset form and signature state
          self.rating = 0
          self.ratingFeedback = ''
          self.completionChecklistSelections = []
          self.completionIsSigned = false
          self.completionSignatureEmpty = true
          self.$nextTick(() => {
            if (self.$refs.completionSignaturePad) {
              self.$refs.completionSignaturePad.clearSignature()
            }
          })
        } else {
          self.toggleDialog({
            status: true,
            title: 'Error',
            message: 'Failed to update appointment status'
          })
        }
      } catch (err) {
        console.error('completeEvent error:', err)
        self.toggleDialog({
          status: true,
          title: 'Error',
          message: err.message || 'Something went wrong while completing the appointment.'
        })
      } finally {
        self.loading = false
      }
    },

    async studentFreeBookingsAvailale(studentId) {
      /**
       * Returns the student's package entitlement for this booking:
       * { hasPackage, hasFreeBookings, packageData, freeBookings }
       * - no package        -> completion is blocked with a clear message
       * - no freeBookings   -> every booking is chargeable (intended behavior)
       * - within the limit  -> free booking, no charge
       * - beyond the limit  -> chargeable
       */
      const student = await new Parse.Query('_User').get(studentId)
      const packageId = student.get('packageId')
      if (!packageId) {
        return { hasPackage: false, hasFreeBookings: false, packageData: null, freeBookings: 0 }
      }
      console.log('Package ID: ', packageId)
      const packageData = await new Parse.Query('SchoolPackages').get(packageId)
      console.log('Package data: ', packageData?.get('freeBookings'))
      const freeBookings = parseInt(packageData?.get('freeBookings'))

      // Package saved without a freeBookings value: every booking is chargeable.
      if (Number.isNaN(freeBookings)) {
        return { hasPackage: true, hasFreeBookings: false, packageData, freeBookings: 0 }
      }
      // Zero/negative freeBookings value: treated as no limit (legacy behavior).
      if (freeBookings <= 0) {
        return { hasPackage: true, hasFreeBookings: true, packageData, freeBookings }
      }

      // Get current count of completed appointments
      const studentAppointmentsCount = await this.getStudentAppointments(studentId)

      // Check if current count (including THIS appointment) would exceed limit
      return {
        hasPackage: true,
        hasFreeBookings: (studentAppointmentsCount + 1) <= freeBookings,
        packageData,
        freeBookings
      }
    },

    async getStudentAppointments(studentId) {
      try {
        const Appointment = Parse.Object.extend('Appointments')
        const Student = Parse.Object.extend('_User')
        // Step 1: Create a pointer to the student
        const studentPointer = new Student()
        studentPointer.id = studentId

        // Step 2: Create a query for the Appointment table
        const appointmentQuery = new Parse.Query(Appointment)

        // Step 3: Use the pointer to filter appointments
        appointmentQuery.equalTo('studentId', studentPointer)
        appointmentQuery.containedIn('status', ['Approved', 'Finished'])
        appointmentQuery.include('studentId')
        appointmentQuery.limit(100)

        // Step 4: Fetch results
        const appointments = await appointmentQuery.count()

        // Step 5: Process the results
        console.log('Total Appointments:', appointments)

        return appointments
      } catch (error) {
        console.error('Error fetching student appointments:', error.message)
      }
    },
    async declineEvent() {
      const self = this
      await self.declineAppointment({
        appointmentId: self.appointment.appointmentId,
        status: 'Declined',
        name: self.appointment.name,
        instructorName:
          self.user.get('firstName') + ' ' + self.user.get('lastName'),
        date: self.appointment.start,
        email: self.appointment.studentEmail
      })
      if (self.declineAppment) {
        if (typeof self.appointment.deviceId !== 'undefined') {
          await self.sendPushNotification({
            player_id: self.appointment.deviceId,
            message:
              'Your appointment has been declined for ' + self.appointment.name,
            type: 'noti',
            senderId: self.user.id,
            name: self.user.get('firstName') + ' ' + self.user.get('lastName')
          })
        }
        await self.init()
        self.toggleDialog({
          status: true,
          title: 'Success',
          message:
            'This appointment has been declined, student will be notified!'
        })
        self.appointments = self.appointments.map((appointment) =>
          self.appointment.appointmentId === appointment.appointmentId
            ? { ...appointment, color: self.getColor(status), status }
            : appointment
        )
      } else {
        self.toggleDialog({
          status: true,
          title: 'Error',
          message: 'Something went wrong, please try again.'
        })
      }
      self.dialog = false
      self.appointment = null
    },
    addToCalendar() {
      /** Only on mobile app */
      if (typeof window.cordova !== 'undefined') {
        // prep some variables
        var startDate = new Date(this.appointment.start) // beware: month 0 = january, 11 = december
        var endDate = new Date(this.appointment.end)
        var title = 'DriverX Appointment'
        var eventLocation = this.appointment.location
        var notes = this.appointment.notes

        var success = () => {
          this.toggleDialog({
            status: true,
            title: 'Success',
            message: "This appointment has been sync'd with your calendar"
          })
        }

        var error = () => {
          this.toggleDialog({
            status: true,
            title: 'Error',
            message: 'Something went wrong, please try again.'
          })
        }

        window.plugins.calendar.createEvent(
          title,
          eventLocation,
          notes,
          startDate,
          endDate,
          success,
          error
        )
      }
    },
    async rescheduleEvent() {
      const self = this
      await self.rescheduleAppointment({
        appointmentId: self.appointment.appointmentId,
        name: self.appointment.name,
        senderName:
          self.user.get('firstName') + ' ' + self.user.get('lastName'),
        date: self.appointment.start,
        email: self.appointment.studentEmail,
        note: self.rescheduleEventNotes
      })
      if (self.rescheduleAppment) {
        /** send push notification to the student */
        if (typeof self.appointment.deviceId !== 'undefined') {
          await self.sendPushNotification({
            player_id: self.appointment.deviceId,
            message:
              'Your appointment has been rescheduled for ' +
              self.appointment.name,
            type: 'noti',
            senderId: self.user.id,
            name: self.user.get('firstName') + ' ' + self.user.get('lastName')
          })
        }
        await self.init()
        self.toggleDialog({
          status: true,
          title: 'Success',
          message: 'A reschedule request has been sent'
        })
        self.appointments = self.appointments.filter(
          (appointment) =>
            self.appointment.appointmentId !== appointment.appointmentId
        )
      } else {
        self.toggleDialog({
          status: true,
          title: 'Error',
          message: 'Something went wrong, please try again.'
        })
      }
      this.confirm = false
      self.dialog = false
      self.appointment = null
    },
    async runSearch() {
      this.loading = true
      await this.init()
    },
    onDateRangeOk() {
      this.datePickerDialog = false
      if (this.$refs.datePickerDialog) this.$refs.datePickerDialog.save(this.selectedDates)
      this.runSearch()
    },
  },
  async created() {
    /** Get instructors appointments */
    await this.init()
    var selfCa = this

    setTimeout(function () {
      window.handleOpenURL = function (url) {
        var id = url.replace('dxapp://appId=', '')
        if (selfCa.appointments) {
          var appnt = null
          // NUiuOqnS2g
          appnt = selfCa.appointments.filter(function (appointment) {
            return id === appointment.appointmentId
          })
          if (appnt) {
            selfCa.appointment = appnt[0]
            selfCa.dialog = true
          }
        }
      }
    }, 0)

    /**
     * Instructors are paid by e-transfer now, so Stripe payout setup is no longer
     * required — skip the check so the "add your payout" warning never shows.
     */
    this.bankingInfoAdded = true
    /** Check if the instructor added the bank and other stripe details */
    // if (
    //   typeof this.user.get('stripeUserAccountId') !== 'undefined' &&
    //   this.user.get('stripeUserAccountId') !== ''
    // ) {
    //   /** Let's see if this user is still active with the subscription */
    //   var aData = {
    //     ownerAccountId: this.user.get('stripeUserAccountId')
    //   }
    //   await Parse.Cloud.run('getStripeUserAccount', aData).then(
    //     async (aResult) => {
    //       console.log(aResult)
    //       if (aResult) {
    //         if (aResult.details_submitted) {
    //           this.bankingInfoAdded = true
    //           this.updateUser({
    //             stripeSubscriptionActive: true
    //           })
    //         } else {
    //           this.bankingInfoAdded = false
    //           this.updateUser({
    //             stripeSubscriptionActive: false
    //           })
    //         }
    //       } else {
    //         this.bankingInfoAdded = false
    //       }
    //     },
    //     (error) => {
    //       this.bankingInfoAdded = false
    //       console.log(error)
    //     }
    //   )
    // } else {
    //   this.bankingInfoAdded = false
    // }

    // did the instructor add packages?
    if (this.user.get('packageAdded')) {
      this.packageDone = true
    }
    if (
      this.user.get('instructorSafety') !== undefined &&
      this.user.get('instructorDriverAbstract') !== undefined &&
      this.user.get('instructor2MilLiability') !== undefined &&
      this.user.get('instructorSafety') !== '' &&
      this.user.get('instructorDriverAbstract') !== '' &&
      this.user.get('instructor2MilLiability') !== ''
    ) {
      this.docsDone = true
    }
  }
}
</script>

<style scoped>
.complete-booking-card {
  border-radius: 12px;
  overflow: hidden;
}

.signature-section {
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  padding: 10px;
  background: #fafafa;
}

.completion-signature-pad {
  width: 100%;
  height: 140px;
  border: 2px dashed rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  background: #fff;
  touch-action: none;
}

.completion-signature-pad>>>canvas {
  border-radius: 4px;
  width: 100% !important;
  height: 136px !important;
}

/* Safe area at top on mobile so content doesn't sit under notch/status bar */
.dashboard-appointments-mobile.rounded {
  padding-top: constant(safe-area-inset-top, 0px);
  padding-top: env(safe-area-inset-top, 0px);
  height: calc(100vh - 88px - constant(safe-area-inset-top, 0px)) !important;
  height: calc(100vh - 88px - env(safe-area-inset-top, 0px)) !important;
}
</style>
